import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  transitId: string;
  houseConsignmentIndex: number;
  file: File;
}

export const useUploadHouseConsignmentItems = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, houseConsignmentIndex, file }: TransitProps) => {
      const formData = new FormData();
      if (file) {
        formData.append('file', file);

        const { data } = await request({
          path: `transits/${transitId}/${houseConsignmentIndex}/upload-house-consignment-items`,
          method: 'POST',
          authenticate: true,
          dataObject: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return data;
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.transitId] });
      toast.success(`New house consignment items were uploaded!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error uploading the house consignment items!`);
    },
  });
};
